import type { Pathnames } from "next-intl/routing";
import { locales } from "./locales";

/**
 * Localized URL pathnames per locale.
 * English (en) remains at root with canonical English slugs.
 * Localized slugs target native search intent.
 */
export const pathnames = {
  "/": "/",
  "/about": {
    en: "/about",
    es: "/acerca-de",
    "pt-BR": "/sobre",
    hi: "/about",
    id: "/tentang",
  },
  "/privacy": {
    en: "/privacy",
    es: "/privacidad",
    "pt-BR": "/privacidade",
    hi: "/privacy",
    id: "/privasi",
  },
  "/terms": {
    en: "/terms",
    es: "/terminos",
    "pt-BR": "/termos",
    hi: "/terms",
    id: "/syarat-ketentuan",
  },
  "/cookies": {
    en: "/cookies",
    es: "/cookies",
    "pt-BR": "/cookies",
    hi: "/cookies",
    id: "/cookies",
  },
  "/contact": {
    en: "/contact",
    es: "/contacto",
    "pt-BR": "/contato",
    hi: "/contact",
    id: "/kontak",
  },

  // Tools
  "/pdf-merge-split": {
    en: "/pdf-merge-split",
    es: "/unir-pdf",
    "pt-BR": "/juntar-pdf",
    hi: "/pdf-jodein",
    id: "/gabung-pdf",
  },
  "/image-compressor": {
    en: "/image-compressor",
    es: "/comprimir-imagen",
    "pt-BR": "/comprimir-imagem",
    hi: "/image-compress",
    id: "/kompres-foto",
  },
  "/word-counter": {
    en: "/word-counter",
    es: "/contador-de-palabras",
    "pt-BR": "/contador-de-palavras",
    hi: "/shabd-counter",
    id: "/penghitung-kata",
  },
  "/qr-code-generator": {
    en: "/qr-code-generator",
    es: "/generador-codigo-qr",
    "pt-BR": "/gerador-codigo-qr",
    hi: "/qr-code-generator",
    id: "/pembuat-kode-qr",
  },
  "/password-generator": {
    en: "/password-generator",
    es: "/generador-de-contrasenas",
    "pt-BR": "/gerador-de-senhas",
    hi: "/password-generator",
    id: "/pembuat-kata-sandi",
  },
  "/unit-converter": {
    en: "/unit-converter",
    es: "/conversor-de-unidades",
    "pt-BR": "/conversor-de-unidades",
    hi: "/unit-converter",
    id: "/konverter-satuan",
  },
  "/hsb-colour-picker": {
    en: "/hsb-colour-picker",
    es: "/selector-de-color-hsb",
    "pt-BR": "/seletor-de-cores-hsb",
    hi: "/color-picker",
    id: "/pemilih-warna-hsb",
  },
  "/color-picker": {
    en: "/color-picker",
    es: "/selector-de-color",
    "pt-BR": "/seletor-de-cores",
    hi: "/color-picker",
    id: "/pemilih-warna",
  },
  "/case-converter": {
    en: "/case-converter",
    es: "/convertidor-mayusculas-minusculas",
    "pt-BR": "/conversor-maiusculas-minusculas",
    hi: "/case-converter",
    id: "/konverter-huruf",
  },
  "/image-cropper": {
    en: "/image-cropper",
    es: "/recortar-imagen",
    "pt-BR": "/recortar-imagem",
    hi: "/image-cropper",
    id: "/potong-gambar",
  },
  "/fancy-text-generator": {
    en: "/fancy-text-generator",
    es: "/letras-bonitas",
    "pt-BR": "/letras-diferentes",
    hi: "/fancy-text-generator",
    id: "/font-aesthetic",
  },
  "/base64-encoder": {
    en: "/base64-encoder",
    es: "/codificador-base64",
    "pt-BR": "/codificador-base64",
    hi: "/base64-encoder",
    id: "/konverter-base64",
  },
  "/markdown-to-html": {
    en: "/markdown-to-html",
    es: "/convertir-markdown-a-html",
    "pt-BR": "/converter-markdown-em-html",
    hi: "/markdown-to-html",
    id: "/markdown-ke-html",
  },
} as const satisfies Pathnames<typeof locales>;

export type AppPathname = keyof typeof pathnames;

